import React from 'react';
import styles from './NotAuthorizedScreen.module.scss';

const NotAuthorizedScreen: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.logoPlaceholder} />
    <div className={styles.text}>Please authenticate to play</div>
  </div>
);

export default NotAuthorizedScreen;
